import React from 'react';
import { IProps } from './type';

const StarIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.021 17.6111C12.7389 17.4446 12.3886 17.4447 12.1064 17.6111L6.83426 20.7214L8.22597 14.8903C8.30476 14.5602 8.19115 14.2138 7.93215 13.9945L3.30811 10.0791L9.41588 9.57256C9.74651 9.54514 10.0352 9.33805 10.1672 9.03367L12.5637 3.50684L14.9602 9.03367C15.0922 9.33805 15.3809 9.54514 15.7116 9.57256L21.8193 10.0791L17.1953 13.9945C16.9363 14.2138 16.8227 14.5602 16.9015 14.8903L18.2932 20.7214L13.021 17.6111ZM6.77962 20.9503L6.77968 20.9501L6.77962 20.9503ZM3.12385 9.92303C3.12389 9.92306 3.12393 9.9231 3.12397 9.92313L3.12385 9.92303L3.05923 9.99935L3.12385 9.92303ZM18.3478 20.9503C18.3478 20.9502 18.3478 20.9502 18.3478 20.9501L18.3478 20.9503Z"
        stroke={strokeColor ? strokeColor : "#212121"} />
    </svg>
  )
};

export default StarIcon;
